import React from "react";
import { Container, Typography, Grid, Box, Paper, styled } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import SupportIcon from "@mui/icons-material/Support";
import BusinessIcon from "@mui/icons-material/Business";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: "100%",
  background: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(10px)",
  borderRadius: "20px",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-5px)",
  },
}));

const ContactIconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  "& .MuiSvgIcon-root": {
    fontSize: "1.8rem",
    marginRight: theme.spacing(1.5),
    color: "#5BB5D9",
  },
}));

function Contact() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography
        variant="h2"
        align="center"
        sx={{
          mb: 4,
          color: "#5BB5D9",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "0.1em",
        }}
      >
        Let's Connect With Us!
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <StyledPaper elevation={3}>
            <Typography
              variant="h4"
              sx={{ mb: 3, color: "#5BB5D9", fontWeight: "bold" }}
            >
              Contact Information
            </Typography>

            <ContactIconBox>
              <BusinessIcon />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  Corporate Office:
                </Typography>
                <Typography>
                  SRS PERFECTION INDIA
                  <br />
                  N5/248, IRC VILLAGE, NAYAPALLI,
                  <br />
                  BHUBANESWAR – 751 015
                </Typography>
              </Box>
            </ContactIconBox>

            <ContactIconBox>
              <PhoneIcon />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  Phone Numbers:
                </Typography>
                <Typography>+91-9040080403</Typography>
              </Box>
            </ContactIconBox>

            <ContactIconBox>
              <SupportIcon />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  Support:
                </Typography>
                <Typography>SUPPORT@SPIOPL.COM</Typography>
              </Box>
            </ContactIconBox>

            <ContactIconBox sx={{ mb: 0 }}>
              {/* <EmailIcon /> */}
              {/* <Box>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  Sales:
                </Typography>
                <Typography>SALES@SPIOPL.COM</Typography>
              </Box> */}
            </ContactIconBox>
          </StyledPaper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src="/images/contact.png"
            alt="Contact Us"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "20px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Contact;
